<template>
    <div>

    </div>
</template>

<script>
    // import Tabs from 'vue-tabs-with-active-line';
    import {mapState} from "vuex";

    const TABS = [
        {
            title: 'API Keys and Webhooks',
            value: 'tab1',
        },
        // {
        //   title: 'Animated',
        //   value: 'tab2',
        // }
    ];

    export default {
        components: {
        },
        data: () => ({
            heading: 'Tabs',
            subheading: 'Tabs are used to split content between multiple sections. Wide variety available.',
            icon: 'pe-7s-drawer icon-gradient bg-happy-itmeo',

            tabs: TABS,
            currentTab: 'tab1',
        }),

        methods: {
            handleClick(newTab) {
                this.currentTab = newTab;
            },
        },
        created() {
            //window.location.href = ""
            this.$router.absUrl('https://developer.rubiesbank.io')
        },
        mounted() {
            // window.location.href = "https://developer.rubiesbank.io"
            this.$router.go(-1)
        },
        computed:{
            ...mapState([
                'system'
            ])
        }
    }
</script>
